import { render, staticRenderFns } from "./SelecRegistrationModality.vue?vue&type=template&id=deb2eb40"
import script from "./SelecRegistrationModality.vue?vue&type=script&lang=js"
export * from "./SelecRegistrationModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports